import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';
import { TriOptionsModel } from '../../../../../../../FrontDeskModule/Shared/components/FrontDeskToolbar';
import { InHouseReportFormModel } from '../../models';

export const getDefaultValues = (globalSettings: GlobalSettingsModel): InHouseReportFormModel => ({
  date: globalSettings?.frontend_date,
  card_ids: [],
  rate_ids: [],
  room_type_ids: [],
  day_price: false,
  all_pax: false,
  nationality_ids: null,
  sortBy: TriOptionsModel.arrival_date,
  sortDirection: 'asc',
  grouped: true,
  file_type: 'pdf',
});
